import {
  RentalPropertyFilterDto,
  PaginatedRentalResponse,
  RentalPropertyResponseDto,
} from "../dtos/property-management/rental-property.dto";
import { SubmitRentalFormDto } from "../dtos/property-management/rental-request-form.dto";
import { newApi, unlockedFormsApi } from "./api.instance";

export class RentalsApis {
  public static filter = async (
    filters: RentalPropertyFilterDto,
    language?: string
  ): Promise<PaginatedRentalResponse> => {
    return newApi()
      .post<PaginatedRentalResponse>(
        `/v1/property-management/filter${language ? `?language=${language}` : ""}`,
        filters
      )
      .then(({ data }) => data);
  };

  public static getById = async (
    id: number,
    language?: string
  ): Promise<RentalPropertyResponseDto> => {
    return newApi()
      .get<RentalPropertyResponseDto>(
        `/v1/property-management/rental/${id}${language ? `?language=${language}` : ""}`
      )
      .then(({ data }) => data);
  };


  static submitRentalForm = async (
    values: any,
    customerNumber: { value: string | undefined },
    location?:any
  ) => {
    const payload: SubmitRentalFormDto = {
      name: values.contact_name,
      phoneNumber: customerNumber.value ?? "",

      areaId: values.area?.value ? Number(values.area.value) : undefined,
      compoundId: values.compound?.value ? Number(values.compound.value) : undefined,
      propertyTypeId: values.property_type?.value ? Number(values.property_type.value) : undefined,
      propertyId: location?.propertyId ? Number(location.propertyId) : undefined,

      budgetFrom: values.budget?.value ? Number(values.budget.value.from) : undefined,
      budgetTo: values.budget?.value ? Number(values.budget.value.to) : undefined,

      from: values.from_date, 
      to: values.to_date,     

      occupants: values.occupants ?? 1,
      bedrooms: values.bedrooms ?? undefined,

      message: values.contact_notes || undefined,
    };

    return unlockedFormsApi().post("/rental-request", payload);
  };
}
